// extracted by mini-css-extract-plugin
export default {"DiscoveryPage":"DiscoveryPage_DiscoveryPage__+Emxa","DiscoveryLayout":"DiscoveryPage_DiscoveryLayout__TwoL3","LeftSection":"DiscoveryPage_LeftSection__36yIx"};